import React, { PureComponent } from 'react'
import { formatSeconds } from '../../../utils/time'

class BlockStartTime extends PureComponent {
    render() {
        let time = '-';
        if (this.props.time !== null) {
            time = formatSeconds(this.props.time);
        }
        return (
            <time className="time" contentEditable={false}>{time}</time>
        )
    }
}

export default BlockStartTime;
